import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PoolService } from "src/app/services/pool.service";

@Component({
  selector: "app-dialog-leave-detail",
  templateUrl: "./dialog-leave-detail.html",
  styleUrls: ["./dialog-leave-detail.scss"],
})
export class DialogLeaveDetail {
  constructor(
    public dialogRef: MatDialogRef<DialogLeaveDetail>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private poolService: PoolService,
  ) {}

  // status: true ise Approve, false ise Reject
  processAction(status: boolean): void {
    this.dialogRef.close({
      approved: status,
      rejected: !status,
      record: this.data.leaveRecord, // Hangi satır olduğunu bilmek için kaydın kendisi
    });
  }
}
